export default "__VITE_ASSET__DTuOx7x8__"